import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import GenericDetails from './GenericDetails';
import { get_donor_by_id, delete_donor } from "../api/donor_api";
import '../styles/BeneficiaryDetails.css';
import Donations from './Donations';

const DonorDetails = () => {
    const { donor_id } = useParams();
    const navigate = useNavigate();
    const [donor, setDonor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        if (!donor_id) {
            navigate('/donors');
            return;
        }
    }, [donor_id, navigate]);

    useEffect(() => {
        let timeoutId;

        const fetchData = async () => {
            try {
                const data = await get_donor_by_id(donor_id);
                if (!data) throw new Error("Donor not found");
                setDonor(data);
            } catch (err) {
                console.error("Error loading donor:", err);
                setError("התורם לא נמצא");

                timeoutId = setTimeout(() => {
                    navigate('/donors');
                }, 2000);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [donor_id, navigate]);


    const handleUpdateClick = () => navigate(`/donors/${donor_id}/update`);
    const handleAddDonationClick = () => navigate(`/donors/${donor_id}/donations/add`);

    const handleDeleteClick = async () => {
        if (!window.confirm('האם אתה בטוח שברצונך למחוק את התורם? פעולה זו אינה הפיכה.')) return;

        try {
            await delete_donor(donor_id);
            alert('נמחק בהצלחה');
            navigate('/donors');
        } catch (err) {
            console.error(err);
            alert('אירעה שגיאה בעת ניסיון המחיקה');
        }
    };

    if (loading) return <div>טוען...</div>;
    if (error) return <div>{error}</div>;
    if (!donor) return null;

    return (
        <>
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>

            <div className="beneficiary-details-container">
                <GenericDetails data={donor} type="donor" />

                <div className="buttons-container">
                    <button className="action-btn" onClick={handleAddDonationClick}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#EF5DA8"
                            strokeWidth="2"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                            <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        הוספת תרומה
                    </button>

                    <button className="action-btn" onClick={handleUpdateClick}><svg viewBox="0 0 24 24" fill="none">
                        <path d="M12 20h9" strokeWidth="2" />
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" strokeWidth="2" />
                    </svg> עדכון פרטים</button>
                    <button className="action-btn" onClick={handleDeleteClick}>  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M3 5.5H17" />
                        <path d="M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5" />
                        <path d="M9 8.5V15.5" />
                        <path d="M11 8.5V15.5" />
                        <path d="M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                    </svg>מחיקה</button>
                </div>

                <Donations donor={donor} />
            </div>
        </>
    );
};

export default DonorDetails;

